import { render, staticRenderFns } from "./PermAdd.vue?vue&type=template&id=7e76a7b8&scoped=true"
import script from "./PermAdd.vue?vue&type=script&lang=js"
export * from "./PermAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e76a7b8",
  null
  
)

export default component.exports